import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '../../Atoms/Icon';
import Input from '../../Atoms/Input';

const SearchField = ({
  placeholder = 'Search...',
  onSearch,
  initialValue = '',
  showButton = true,
  error = false,
  className = '',
  ...props
}) => {
  const [query, setQuery] = useState(initialValue);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSearch) onSearch(query);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={['searchfield', className].filter(Boolean).join(' ')}
      {...props}
    >
      

        <div className={['input-group', error ? 'input-group-error' : ''].filter(Boolean).join(' ')}>
          <Input
            type="search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={placeholder}
            className="input--in-group"
            aria-label="Search"
          />

          {showButton && (
            <button
              type="submit"
              className="searchfield-submit"
              aria-label="Submit search"
            >
              <Icon name="MdOutlineSearch" className="searchfield-submit-icon" />
            </button>
          )}
        </div>
    </form>
  );
};

SearchField.propTypes = {
  onSearch: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  initialValue: PropTypes.string,
  showButton: PropTypes.bool,
  error: PropTypes.bool,
  className: PropTypes.string,
};

export default SearchField;
